import { render, staticRenderFns } from "./LegalInfo.vue?vue&type=template&id=17a9e745&scoped=true"
import script from "./LegalInfo.vue?vue&type=script&lang=ts"
export * from "./LegalInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a9e745",
  null
  
)

export default component.exports